import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addProjectVirtualResource(
    request: Boundaries["addProjectVirtualResource"]["request"],
  ): void;
}

function useAddProjectVirtualResource(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAddProjectVirtualResourceRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAddProjectVirtualResourceRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAddProjectVirtualResourceRequestFailure,
    ),
    addProjectVirtualResource: core.addProjectVirtualResource,
  };
}

export { useAddProjectVirtualResource };
